import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { useDispatch } from 'react-redux';

import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import AuthSlice from 'features/Auth/Slices/auth';

const useStyles = makeStyles((theme) => ({
	profilePopover: {
		minWidth: theme.spacing(30),
	},
	switchTabLabel: {
		fontSize: theme.spacing(2),
		fontWeight: 500,
	},
	avatar: {
		background: theme.palette.primary.main,
		fontSize: theme.spacing(2),
	},
}));

export const formatNameInitials = (val: string): string => {
	const words = val?.split(' ');
	if (words?.length === 1) return words[0]?.charAt(0).toUpperCase();
	return words?.[0]?.charAt(0)?.toUpperCase() + words?.[words?.length - 1]?.charAt(0).toUpperCase();
};

const ProfileDialog: React.FC = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { keycloak } = useKeycloak();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const menuOpen = Boolean(anchorEl);
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleLogout = () => {
		setAnchorEl(null);
		dispatch(AuthSlice.actions.LOG_OUT());
	};

	return (
		<>
			<IconButton
				data-testid="avatar-icon"
				color="inherit"
				aria-controls="fade-menu"
				aria-haspopup="true"
				onClick={handleAvatarClick}>
				<Avatar className={classes.avatar}>{formatNameInitials(keycloak.idTokenParsed?.name)}</Avatar>
			</IconButton>
			<Popover
				id="profile-menu-popover"
				open={menuOpen}
				anchorEl={anchorEl}
				onClose={handleClose}
				transitionDuration={800}
				TransitionComponent={Fade}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				classes={{ paper: classes.profilePopover }}>
				<List component="nav">
					<ListItem divider>
						<Box flexDirection="column" flexGrow={1} textAlign="center">
							<Avatar style={{ margin: 'auto' }} alt={keycloak.idTokenParsed?.name} />
							<Typography component="p" variant="h6" style={{ margin: 'auto' }}>
								{keycloak.idTokenParsed?.name}
							</Typography>
							<Typography component="span" variant="caption">
								{keycloak.idTokenParsed?.phone}
							</Typography>
						</Box>
					</ListItem>
					<ListItem button onClick={handleLogout}>
						Logout
					</ListItem>
				</List>
			</Popover>
		</>
	);
};

export default React.memo(ProfileDialog);
